import { render, staticRenderFns } from "./BillingVirtualProvider.vue?vue&type=template&id=0edb8a4a&"
import script from "./BillingVirtualProvider.vue?vue&type=script&lang=js&"
export * from "./BillingVirtualProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports